import script from "./BasicSearchPage.vue?vue&type=script&setup=true&lang=js"
export * from "./BasicSearchPage.vue?vue&type=script&setup=true&lang=js"

import "./BasicSearchPage.vue?vue&type=style&index=0&id=43b1afe2&scoped=true&lang=css"
import "./BasicSearchPage.vue?vue&type=style&index=1&id=43b1afe2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43b1afe2"]])

export default __exports__